import React from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton, Badge, Breadcrumbs, Link, Chip } from '@mui/material';
import { Notifications, NavigateNext } from '@mui/icons-material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const pageTitles: Record<string, { title: string; subtitle: string }> = {
  '/dashboard': { title: 'Dashboard', subtitle: 'Overview of hospital operations' },
  '/hospitals': { title: 'Hospitals', subtitle: 'Manage and onboard hospitals' },
  '/patients': { title: 'Patients', subtitle: 'Patient registry and records' },
  '/appointments': { title: 'Appointments', subtitle: 'Schedule and manage appointments' },
  '/inventory': { title: 'Inventory', subtitle: 'Stock and supply management' },
  '/billing': { title: 'Billing', subtitle: 'Invoices and payments' },
  '/staff': { title: 'Staff', subtitle: 'Manage hospital staff' },
};

const Layout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const page = pageTitles[location.pathname] || { title: 'HMS', subtitle: '' };
  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f0f4f8' }}>
      <Sidebar />
      <Box sx={{ flex: 1, ml: `${DRAWER_WIDTH}px`, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Top Bar */}
        <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'white', borderBottom: '1px solid #e2e8f0', zIndex: 100 }}>
          <Toolbar sx={{ minHeight: '64px !important', px: 3 }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', fontSize: 17 }}>{page.title}</Typography>
              <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: 12 }}>{today}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Chip
                label={user?.hospital?.name || 'Super Admin'}
                size="small"
                sx={{ bgcolor: '#eff6ff', color: '#3b82f6', fontWeight: 600, fontSize: 11, border: '1px solid #bfdbfe' }}
              />
              <IconButton size="small" sx={{ bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                <Badge badgeContent={3} color="error">
                  <Notifications sx={{ fontSize: 20, color: '#64748b' }} />
                </Badge>
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Page Content */}
        <Box sx={{ flex: 1, p: 3, overflowY: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
